export const COMPANY_TAB_VALUES = {
  GENERAL: 'General',
  VENDOR_RELATIONS: 'Vendor relations',
  BUSINESS_UNIT_RELATIONS: 'Business unit relations',
  ORDERS: 'Orders',
  DOCUMENTS: 'Documents',
  PRICEBOOKS: 'Pricebooks',
  SALES_ORDER: 'Sales Order'
};

export const COMPANY_TABS = [
  {
    value: 'General',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Orders',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Documents',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Pricebooks',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Sales Order',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];

export const CUSTOMER_TABS = [
  {
    value: 'Info & Companies',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Compliance check',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];

export const INVITE_TABS = [
  {
    value: 'Vendor',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Admin',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];

export const POWER_BI_TABS = [
  {
    value: 'Order information',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Vendor overview',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];

export const getVendorTabs = (isUserPermissionsEnabled) => {
  const VENDOR_TABS = [
    {
      value: 'About Vendor',
      badge: {
        content: '',
        color: '',
        backgroundColor: ''
      }
    }
  ];

  if (!isUserPermissionsEnabled) {
    VENDOR_TABS.push({
      value: 'Automation Settings',
      badge: {
        content: '',
        color: '',
        backgroundColor: ''
      }
    });
  }

  return VENDOR_TABS;
}

export const VENDOR_SETTING_TABS = [
  {
    value: 'About Vendor',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Email Notifications',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];


export const getBrandTabs = (isUserPermissionsEnabled) => {
  const BRAND_TABS = [
    {
      value: 'About Brand',
      badge: {
        content: '',
        color: '',
        backgroundColor: ''
      }
    }
  ];

  if (!isUserPermissionsEnabled) {
    BRAND_TABS.push({
      value: 'Automation Settings',
      badge: {
        content: '',
        color: '',
        backgroundColor: ''
      }
    });
  }
  
  return BRAND_TABS;
}

export const ORGANIZATION_TABS = [
  {
    value: 'Business Units',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'All Users',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];

export const ORGANIZATION_TABS_WITH_ADMINS = [
  {
    value: 'Business Units',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'All Users',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Admins',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];

export const BUSINESS_UNIT_DETAILS_TABS = [
  {
    value: 'About',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  },
  {
    value: 'Users',
    badge: {
      content: '',
      color: '',
      backgroundColor: ''
    }
  }
];